<template>
  <router-view />
</template>

<script>

export default {
  name: 'CurrencyWrapper'
}
</script>
